import React from "react";
import { Grid, useMediaQuery } from "@material-ui/core";
import ExportPdf from "./ExportPdf";
import { getCurrentYear } from "utility/date";

const Footer = () => {
  const matchesMediaQuery = useMediaQuery("(min-width: 600px)");
  return (
    <Grid
      container
      style={{
        height: 95,
        background: "#1A1A1A",
        marginTop: matchesMediaQuery ? 0 : 40,
      }}
    >
      <Grid
        item
        xs={12}
        style={{
          height: "calc(100% - 52px)",
          position: "relative",
        }}
      >
        <Grid
          container
          item
          xs={10}
          justifyContent={matchesMediaQuery ? "flex-end" : "center"}
          style={{ margin: "auto" }}
        >
          <ExportPdf />
        </Grid>
      </Grid>
      <Grid
        container
        item
        xs={12}
        style={{ height: 30 }}
        justifyContent="center"
        alignContent="flex-end"
      >
        <p
          style={{
            color: "#666666",
            textAlign: "center",
            fontSize: "min(max(.7em, 3vw), 1em)",
            margin: 0,
          }}
        >
          © {getCurrentYear()} Forea Capital Oy. All rights reserved.
          {matchesMediaQuery ? " | " : <br />}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://forea.fi/wp-content/uploads/BEST-EXECUTION-2019.pdf"
            style={{ color: "#666666", textDecoration: "none" }}
          >
            Best Execution (in Finnish){" "}
          </a>{" "}
          |{" "}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://forea.fi/wp-content/uploads/Tietoja-ForeaCapitalOy.pdf"
            style={{ color: "#666666", textDecoration: "none" }}
          >
            Customer Information (in Finnish){" "}
          </a>
        </p>
      </Grid>
    </Grid>
  );
};

export default React.memo(Footer);
